import type { App } from 'vue'
import resizable from './resizable'
import dragScroll from './drag-scroll'
import wheelScroll from './wheel-scroll'
import tooltip from './tooltip'
import drag from './drag'
import limitNumber from './limit-number'
import amount from './amount'
import ripple from './ripple'

export function registerDirective(app: App) {
  app.directive('resizable', resizable)
  app.directive('drag-scroll', dragScroll)
  app.directive('wheel-scroll', wheelScroll)
  app.directive('drag', drag)
  app.directive('tooltip', tooltip)
  app.directive('amount', amount)
  app.directive('ripple', ripple)
  app.directive('limit-number', limitNumber)
}
